package com.ashes.dev.ai.weather.weathershow

import androidx.compose.ui.graphics.Color
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WeatherResponse(
    val latitude: Double,
    val longitude: Double,
    @SerialName("current_weather")
    val currentWeather: CurrentWeather?,
    @SerialName("daily")
    val daily: Daily?
)

@Serializable
data class CurrentWeather(
    val temperature: Double,
    val windspeed: Double,
    @SerialName("weathercode")
    val weatherCode: Int,
    val time: String
)

@Serializable
data class Daily(
    val time: List<String>,
    @SerialName("weathercode")
    val weatherCode: List<Int>,
    @SerialName("temperature_2m_max")
    val maxTemp: List<Double>,
    @SerialName("temperature_2m_min")
    val minTemp: List<Double>,
    @SerialName("sunrise")
    val sunrise: List<String>,
    @SerialName("sunset")
    val sunset: List<String>
)

data class ForecastDay(
    val date: String,
    val maxTemp: Double,
    val minTemp: Double,
    val weatherCode: Int
)

data class WeatherUIState(
    val address: String = "Loading location...",
    val currentTime: String = "",
    val lastUpdated: String = "",
    val temperature: Double = 0.0,
    val weatherCode: Int = 0,
    val sunrise: String = "",
    val sunset: String = "",
    val forecast: List<ForecastDay> = emptyList(),
    val isLoading: Boolean = false,
    val isAutoUpdateEnabled: Boolean = true,
    val error: String? = null,
    val themeColor: Color = Color(0xFF212121),
    val statusMessage: String? = null,
    val lastLat: Double? = null,
    val lastLon: Double? = null
)
